var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Cm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 210.863C165.228 210.863 210 166.092 210 110.863C210 55.6346 165.228 10.863 110 10.863C54.7715 10.863 10 55.6346 10 110.863C10 166.092 54.7715 210.863 110 210.863ZM110 140.863C126.569 140.863 140 127.432 140 110.863C140 94.2945 126.569 80.863 110 80.863C93.4315 80.863 80 94.2945 80 110.863C80 127.432 93.4315 140.863 110 140.863Z",
    fill: "#CC9B92",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 110,
    cy: 110.863,
    r: 30,
    stroke: "#37A851",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Cm);
export default __webpack_public_path__ + "static/media/3cm.b6c70b0e9f03ee3c64a2bd9fda57e4af.svg";
export { ForwardRef as ReactComponent };